import { AxiosInstance } from 'axios';

import BaseClient from './baseClient';
import { BaseDataResponse } from '../responses';
import { IErrorHandler } from '../abstractions';
import { RatingPublicModel } from '../interfaces';

export default class RatingClient extends BaseClient {
  constructor(errorHandler: IErrorHandler, axiosInstance: AxiosInstance) {
    super(errorHandler, axiosInstance, 'rating');
  }

  public async getRatingsAsync(): Promise<BaseDataResponse<RatingPublicModel[]>> {
    return this.getHttpAsync<BaseDataResponse<RatingPublicModel[]>>('', '');
  }
}
